import { MutableRefObject, RefObject, useEffect } from 'react';


export const useOutOfElDetection = (
  ref: RefObject<HTMLElement>,
  method: (state: boolean) => void
) => {
  const detectClickOutside = ({ target }: MouseEvent) => {
    const { current }: MutableRefObject<HTMLElement | null> = ref;
    if (current && !current.contains(target as Node)) {
      method(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', detectClickOutside);
    return () => {
      document.removeEventListener('click', detectClickOutside);
    };
  }, []);

  return;
};
